export default __webpack_public_path__ + "static/media/CNo.78-2.fbe940f7.jpg";